// This mixin contains code that is used for only gas commercial configs
import Vue from "vue";
// import moment from "moment";
// import { _ } from "vue-underscore";

export default {
  data() {
    return {
      gasConfigTemplate: {
        ApplicationRule: "Always",
        BillingAq: null,
        CcaAgreementDescription: null,
        CcaReductionPercentage:
          Vue.config.honeycomb.commercialConfig.ccaReductionPercentage,
        CclExemptionType: "NotExempt",
        CommercialPercentage:
          Vue.config.honeycomb.commercialConfig.commercialPercentage,
      },
    }
  }
}